import { render, staticRenderFns } from "./ClientForm.vue?vue&type=template&id=d6bc0bde&scoped=true&"
import script from "./ClientForm.vue?vue&type=script&lang=js&"
export * from "./ClientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bc0bde",
  null
  
)

export default component.exports